import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR} from '../theme.js';

export function getRacingConfig() {
    return {
        custom: {
            [PALETTE_IDS.RACE_MEETINGS]: {
                RaceMeeting: {
                    description: {
                        style: {
                            _mobile_alignItems: 'center',
                        },
                    },
                    bestOddsGuaranteed: {
                        hideablePane: {
                            style: {
                                base: {
                                    _mobile_padding: '0 0 8px 8px',
                                },
                            },
                        },
                    },
                },
            },
        },
        palette: {
            [PALETTE_IDS.RACE_CARD]: {
                RACE_CARD_MARKETS_DROPDOWN: {
                    SECONDARY_DROPDOWN_BG: COLOR.BRAND.BACKGROUND4,
                    SECONDARY_DROPDOWN_BORDER_COLOR: COLOR.BRAND.BACKGROUND4,
                },
                RACE_CARD_PREVIEW_BEST_ODDS_RACE_ICON_COLOR: COLOR.BRAND.BACKGROUND5,
            },
            [PALETTE_IDS.RACE_MEETINGS]: {
                RACE_MEETINGS_LIVE_RACE_ICON_COLOR: COLOR.BRAND.ACCENT1,
            },
        },
    };
}
